// extracted by mini-css-extract-plugin
export default {"authorCol":"authorCol_q_iI","imageOnlyAuthorRow":"imageOnlyAuthorRow_les7","imageOnlyAuthorCol":"imageOnlyAuthorCol_uMKf"};